import { Pipe, PipeTransform } from '@angular/core';
import { capitalize, startCase } from 'lodash';
import { UserRolesModel } from '../../store/state/administration/user/models/user-roles.model';

@Pipe({
    name: 'roleGroupPipe',
    standalone: false
})
export class RoleGroupPipe implements PipeTransform {
  transform(value: UserRolesModel): string {
    const [key, values] = Object.entries(value)[0];
    return capitalize(key) + '-' + startCase(values[0]);
  }
}
